import { computed, ComputedRef } from 'vue'

import localeToConditionsUrl from "../../../config/localeToConditionsUrl"

// State
import store from "@/vue/planning/store/store"

const conditionsUrl: ComputedRef<string> = computed(() => {
    const locale: string = store.getters['locale']
    const formattedLocale: string = locale.replaceAll("-", "_")
    const url = localeToConditionsUrl[formattedLocale]
    if (!url) throw new Error("could not get conditions url for locale: " + formattedLocale)
    return url + `?ts=${Date.now()}`
})

export default conditionsUrl